/*
 * TC 헤더 — 데스크탑 드롭다운(hover) + 모바일 패널(slide)
 * 카페24 스크립트 이식. 검색 패널은 미구현이라 closeSearchFn은 no-op.
 */
(function () {
  /* 헤더 하단의 현재 화면상 위치를 --header-bottom 으로 노출.
   * 배너가 스크롤되며 헤더 하단 위치가 변하므로, 그 밑에 붙는 fixed 요소
   * (.tc-list-nav, .tc-panel)가 이 값을 top 으로 사용. */
  var rafId = null;
  function updateHeaderBottom() {
    rafId = null;
    var header = document.querySelector('.tc-header');
    var bottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    document.documentElement.style.setProperty('--header-bottom', bottom + 'px');
  }
  function scheduleHeaderBottom() {
    if (rafId == null) rafId = requestAnimationFrame(updateHeaderBottom);
  }
  window.addEventListener('scroll', scheduleHeaderBottom, { passive: true });
  window.addEventListener('resize', scheduleHeaderBottom, { passive: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHeaderBottom);
  } else {
    updateHeaderBottom();
  }
  window.addEventListener('load', updateHeaderBottom);

  /* 헤더 카트 수량 실시간 갱신: 테마 cart:update 이벤트 수신 */
  document.addEventListener('cart:update', function (e) {
    var el = document.getElementById('tc-cart-num');
    if (!el) return;
    var count = e.detail && e.detail.resource && e.detail.resource.item_count;
    if (count != null) {
      el.textContent = count;
    } else {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (c) { el.textContent = c.item_count; })
        .catch(function () {});
    }
  });

  /* 리전 선택(<details>): 바깥 클릭·Escape 로 닫기. 헤더·패널·푸터 공통 */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.tc-region[open]').forEach(function (el) {
      if (!el.contains(e.target)) el.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.tc-region[open]').forEach(function (el) {
      el.removeAttribute('open');
      if (el.contains(document.activeElement)) el.querySelector('summary').focus();
    });
  });

  function init() {
    var header = document.querySelector('.tc-header');
    if (!header || header.dataset.tcInit === '1') return;
    header.dataset.tcInit = '1';

    var closeSearchFn = function () {};
    var closePanelFn = function () {};

    /* ===== 데스크탑 드롭다운 ===== */
    var depth = header.querySelector('.tc-header-depth');
    var inners = header.querySelectorAll('.tc-header-depth-inner');
    var navBtns = header.querySelectorAll('.tc-nav-btn[data-depth]');

    function openDepth(key) {
      var matched = false;
      inners.forEach(function (el) {
        var isMatch = el.classList.contains('tc-header-depth-inner--' + key);
        el.classList.toggle('is-active', isMatch);
        if (isMatch) matched = true;
      });
      navBtns.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.dataset.depth === key);
      });
      if (matched && depth) depth.classList.add('is-active');
      else closeDepth();
    }

    function closeDepth() {
      if (depth) depth.classList.remove('is-active');
      inners.forEach(function (el) { el.classList.remove('is-active'); });
      navBtns.forEach(function (btn) { btn.classList.remove('is-active'); });
    }

    navBtns.forEach(function (btn) {
      btn.addEventListener('mouseenter', function () { openDepth(btn.dataset.depth); });
    });
    header.addEventListener('mouseleave', closeDepth);
    document.addEventListener('click', function (e) { if (!header.contains(e.target)) closeDepth(); });
    window.addEventListener('scroll', closeDepth, { passive: true });

    /* ===== 모바일 패널 ===== */
    var panel = document.querySelector('.tc-panel');
    var panelBtn = document.querySelector('.tc-panel-btn');
    var panelCloseBtn = header.querySelector('.tc-util .tc-close-btn');

    if (panel && panelBtn) {
      var panelSavedY = 0;

      var closeAllDepths = function () {
        panel.querySelectorAll('.tc-pn-depth').forEach(function (d) { d.classList.remove('is-active'); });
        panel.querySelectorAll('.tc-pn-label').forEach(function (l) { l.classList.remove('is-active'); });
      };

      /* SHOP(첫 뎁스) 기본 열림 */
      var openFirstDepth = function () {
        var firstDepth = panel.querySelector('.tc-pn-depth');
        if (!firstDepth) return;
        firstDepth.classList.add('is-active');
        var item = firstDepth.closest('.tc-pn-item');
        var label = item ? item.querySelector('.tc-pn-label') : null;
        if (label) label.classList.add('is-active');
      };

      var closePanel = function () {
        if (!panel.classList.contains('is-active')) return;
        panel.classList.remove('is-active');
        header.classList.remove('is-panel-open');
        closeAllDepths();
        document.body.classList.remove('s-p');
        document.body.style.top = '';
        window.scrollTo(0, panelSavedY);
      };
      closePanelFn = closePanel;

      var openPanel = function () {
        if (panel.classList.contains('is-active')) return;
        closeSearchFn();
        panelSavedY = window.scrollY;
        document.body.style.top = '-' + panelSavedY + 'px';
        document.body.classList.add('s-p');
        panel.classList.add('is-active');
        header.classList.add('is-panel-open');
        closeAllDepths();
        openFirstDepth();
      };

      var togglePanel = function () {
        if (panel.classList.contains('is-active')) closePanel();
        else openPanel();
      };

      panelBtn.addEventListener('click', togglePanel);
      if (panelCloseBtn) panelCloseBtn.addEventListener('click', closePanel);

      panel.querySelectorAll('.tc-pn-label').forEach(function (label) {
        label.addEventListener('click', function (e) {
          var item = label.closest('.tc-pn-item');
          var d = item ? item.querySelector('.tc-pn-depth') : null;
          if (!d) return; // 하위 없는 항목은 <a> 링크로 이동
          var wasOpen = d.classList.contains('is-active');
          closeAllDepths();
          if (!wasOpen) {
            d.classList.add('is-active');
            label.classList.add('is-active');
          }
        });
      });
    }

    /* ===== 검색 패널 ===== */
    var searchPanel = document.querySelector('.tc-search-panel');
    var searchBtns = document.querySelectorAll('.tc-search-btn');
    var searchCloseBtn = searchPanel ? searchPanel.querySelector('.tc-search-panel-close-btn') : null;
    var searchCloseBtnM = document.querySelector('.tc-search-panel-close-btn--m');

    if (searchPanel && searchBtns.length) {
      var searchSavedY = 0;

      var closeSearch = function () {
        if (!searchPanel.classList.contains('is-active')) return;
        searchPanel.classList.remove('is-active');
        header.classList.remove('is-search-open');
        document.body.classList.remove('s-p');
        document.body.style.top = '';
        window.scrollTo(0, searchSavedY);
      };
      closeSearchFn = closeSearch;

      var openSearch = function () {
        if (searchPanel.classList.contains('is-active')) return;
        closePanelFn();
        searchSavedY = window.scrollY;
        document.body.style.top = '-' + searchSavedY + 'px';
        document.body.classList.add('s-p');
        searchPanel.classList.add('is-active');
        header.classList.add('is-search-open');
        var input = searchPanel.querySelector('input[type="search"]');
        if (input) setTimeout(function () { input.focus(); }, 50);
      };

      searchBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          openSearch();
        });
      });
      if (searchCloseBtn) searchCloseBtn.addEventListener('click', closeSearch);
      if (searchCloseBtnM) searchCloseBtnM.addEventListener('click', closeSearch);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeSearch();
      });
    }

    /* ===== 이벤트 스와이퍼 (모바일 전용) ===== */
    var eventList = document.querySelector('.tc-event-list');
    if (eventList && typeof Swiper !== 'undefined') {
      var mq = window.matchMedia('(max-width: 1023.98px)');
      var eventSwiper = null;

      var initEventSwiper = function () {
        if (eventSwiper) return;
        eventSwiper = new Swiper(eventList, {
          slidesPerView: 'auto',
          spaceBetween: 10,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: eventList.querySelector('.tc-se-next-btn'),
            prevEl: eventList.querySelector('.tc-se-prev-btn'),
          },
        });
      };
      var destroyEventSwiper = function () {
        if (!eventSwiper) return;
        eventSwiper.destroy(true, true);
        eventSwiper = null;
      };
      var handleEventMq = function (e) {
        if (e.matches) initEventSwiper();
        else destroyEventSwiper();
      };
      handleEventMq(mq);
      mq.addEventListener('change', handleEventMq);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    var h = document.querySelector('.tc-header');
    if (h) h.dataset.tcInit = '';
    init();
  });
})();
